import httpClient from "./httpClient";

const END_POINT = "/servicers";
const NOTES_END_POINT = "notes";

const getStaffNotes = servicerId =>
  httpClient.get(`${END_POINT}/${servicerId}/${NOTES_END_POINT}`);

const createStaffNote = (servicerId, data) => {
  return httpClient.post(
    `${END_POINT}/${servicerId}/${NOTES_END_POINT}`,
    prepareFormData(data)
  );
};

const updateStaffNote = (servicerId, data) => {
  const { id, ...form } = data; // remove id from form object
  return httpClient.put(
    `${END_POINT}/${servicerId}/${NOTES_END_POINT}/${data.id}`,
    prepareFormData(form)
  );
};

const deleteStaffNote = (id, servicerId) =>
  httpClient.delete(`${END_POINT}/${servicerId}/${NOTES_END_POINT}/${id}`);

const deleteStaffNoteFile = (id, servicerId, fileId) =>
  httpClient.delete(
    `${END_POINT}/${servicerId}/${NOTES_END_POINT}/${id}?attachment_id=${fileId}`
  );

export {
  getStaffNotes,
  createStaffNote,
  updateStaffNote,
  deleteStaffNote,
  deleteStaffNoteFile
};

function prepareFormData(data) {
  const formData = new FormData();

  for (const key in data) {
    const keyName = `staff_note[${key}]`;
    if (data[key] !== null && key === "documents") {
      for (let i = 0; i < data[key].length; i++) {
        const file = data[key][i];

        formData.append(keyName + "[]", file);
      }
    } else if (data[key] !== null && key !== "uploaded_files") {
      formData.append(keyName, data[key]);
    } else if (data[key] === null) {
      formData.append(keyName, "");
    }
  }

  return formData;
}
